module.exports = __webpack_public_path__ + "img/Manu_L_.8d4319a5.jpg";